export default __webpack_public_path__ + "static/media/Image4.56976b6e.jpg";